const TIMER_KEY = Symbol();

/**
 * throttle decorator
 * 
 * ensures the decorated method will only run once per frame.
 * 
 * @example
 * ```ts
 * class MyEl extends FASTElement {
 *   @throttle()
 * 	 public handleScroll(event: ScrollEvent) { }	
 * }
 * ```
 */
export const throttle = () => {
	return <T>(target: T, propertyKey: string, descriptor: PropertyDescriptor) => {
		const fn = descriptor.value as (this: T & { [TIMER_KEY]: number }, ...args: Array<unknown>) => unknown;

		descriptor.value = function (this: ThisParameterType<typeof fn>, ...args: Parameters<typeof fn>) {
			if (this[TIMER_KEY]) {
				window.cancelAnimationFrame(this[TIMER_KEY]);
			}

			this[TIMER_KEY] = window.requestAnimationFrame(() => {
				fn.apply(this, args);
			});
		}
	}
}